export default [{
  path: '/unitizacoes_obras',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Unitizações Histórico',
      path: 'historico',
      component: () => import('@/views/unitizacoesObras/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: "Unitizações de Obras" }
        ]
      }
    },
    {
      name: 'Unitizações Adicionar',
      path: 'edit',
      component: () => import('@/views/unitizacoesObras/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Unitizações de Obras', path: '/unitizacoes_obras/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Unitizações Editar',
      path: 'edit/:id',
      component: () => import('@/views/unitizacoesObras/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Unitizações de Obras', path: '/unitizacoes_obras/historico' },
          { name: 'Editar' }
        ]
      }
    }
  ]
}]